import * as React from 'react';
import * as _ from 'lodash'
import * as moment from 'moment';
import Progress from '../views/Progress';
import Message from '../views/Message';
import Setup from '../views/Setup';
import SignIn from '../views/SignIn';
import Campaign from './Campaign';
import { apiGetAccount, clientLog, LSKEY_FORCEINTERACTIVELOGIN } from '../util'
import { LSKEY_THEMEMODE } from '../theme'

export interface AppProps {
    apiLinked: boolean;
    title: string;
    isOfficeInitialized: boolean;
    initMustSetup: boolean;
    itemID: string;
    userIdentityToken: string;
    initError: string;
    initEx: string;
    onReset: () => void;
}

export interface AppState {
    account: any;
    signedOut: boolean;
}

const LSKEY_AUTOSIGNINDISABLED = "mm365-autosignindisabled";
const TRUE = "1";
const FALSE = "0";

export default class App extends React.Component<AppProps, AppState> {

    constructor(props, context) {
        super(props, context);
        this.state = {
            account: null,
            signedOut: false,
        };

    }

    async componentDidMount() {
      
    }

    async componentWillReceiveProps(nextProps: AppProps) {
        var autoSignIn = !this.isAutoSignInDisabled();
        if (autoSignIn) {
            clientLog("Automatic sign-in enabled")
        } else {
            clientLog("Automatic sign-in disabled")
        }
        if (nextProps.apiLinked === true && this.props.apiLinked === false) {
            // Linking occurred
            if (autoSignIn) {
                clientLog("autoSignIn true, signing in")
                await this.signIn();
            } else {
                clientLog("autoSignIn false, set state to signed out")
                this.setState({ signedOut: true });
            }
        }
    }

    isAutoSignInDisabled = (): boolean => {
        const value = Office.context.roamingSettings.get(LSKEY_AUTOSIGNINDISABLED);
        console.log("RoamingSettings for Auto-Sign-In: " + value);
        return value === TRUE;
    };

    setAutoSignInDisabled = (autoSignInDisabled: boolean) => {
        if (autoSignInDisabled) {
            clientLog("Deactivating automatic sign-in");
            Office.context.roamingSettings.set(LSKEY_AUTOSIGNINDISABLED, TRUE);
        } else {
            clientLog("Re-enabling automatic sign-in");
            Office.context.roamingSettings.remove(LSKEY_AUTOSIGNINDISABLED);
        }

        // Save changes persistently
        Office.context.roamingSettings.saveAsync((result) => {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
                console.log("RoamingSettings saved.");
                console.log("After settings change, auto-sign is disabled: " + this.isAutoSignInDisabled());
            } else {
                console.error("Failed to save RoamingSettings.", result.error);
            }
        });
    };

    signIn = async () => {
        this.setAutoSignInDisabled(false);

        this.setState({ account: null, signedOut: false }, async () => {
            clientLog("Account null and signedOut false");

            var account = await apiGetAccount();

            clientLog("Current Plan: " + account.plan);
            this.setState({ account });

        });
    }

    autoLogin = (account: any, url: string) => {
        const prefix = "https://applink.mailmerge365.com";
        if (url[0] != "/") return url;
        return `${account.appLink}/autologin?${account.autoLogin}&redirectUri=${encodeURIComponent(url)}`;
    };

    reset = async () => {
        this.setState({ account: null, signedOut: false }, () => this.props.onReset());
    }

    click = async () => {
        /**
         * Insert your Outlook code here
         */
    }

    clearLocal = () => {
        // Keep the theme preference across resets
        let themeMode = null;
        try { themeMode = localStorage.getItem(LSKEY_THEMEMODE); } catch (e) { }

        // Clear all local storage and sessions with try catch around each
        try {
            localStorage.clear();
        } catch (e) { }
        try {
            sessionStorage.clear();
        } catch (e) { }

        try { if (themeMode) localStorage.setItem(LSKEY_THEMEMODE, themeMode); } catch (e) { }

        // Make the next sign-in show the account picker instead of silently
        // re-authenticating via the Office host
        try { localStorage.setItem(LSKEY_FORCEINTERACTIVELOGIN, "1"); } catch (e) { }
    }

    render() {
        const {
            title,
            isOfficeInitialized,
            initMustSetup,
            initError,
            initEx,
            itemID,
            userIdentityToken
        } = this.props;

        const {
            account,
            signedOut,
        } = this.state;

        //return <CampaignView
        //    fileRows={45}
        //    filename="Test.xlsx"
        //    fileDownloadUrl="http://example.org"
        //    fileUploaded={moment()}
        //    onFileUpload={async (event) => { }}
        ///>
        if (initMustSetup && (account == null || account.setupComplete == false)) {
            return (
                <Setup onDone={(account) => this.setState({ account })} userIdentityToken={userIdentityToken } />
            );
        }

        if (initError != null) {
            return (
                <Message
                    account={account}
                    autoLogin={this.autoLogin}
                    onSignout={() => {
                        this.setAutoSignInDisabled(true);
                        this.setState({ signedOut: true, account: null })
                        this.clearLocal();
                    }}
                    title={'There was a problem starting MailMerge365'}
                    message={initError + " As a first step try clicking in the white space below this message (to focus the add-in) and pressing CTRL + R (or CMD + R) to refresh the add-in cache."}
                    additional={initEx}
                    dismissButtonTitle={null}
                />
            );
        }

        if (!isOfficeInitialized) {
            return (
                <Progress
                    title={title}
                    logo='assets/logo-filled.png'
                    message='Waiting for connection to Office...'
                />
            );
        }

        if (account == null && signedOut == true) {
            return (
                <SignIn
                    onSignIn={() => {
                        this.setAutoSignInDisabled(false);
                        this.reset();
                    }}
                />
            );
        }

        if (account == null) {
            return (
                <Progress
                    title={title}
                    logo='assets/logo-filled.png'
                    message='Loading account'
                />
            );
        }

        if (itemID == null) {
            return (
                <Progress
                    title={title}
                    logo='assets/logo-filled.png'
                    message='Loading message'
                />
            );
        }

        return <Campaign
            account={account}
            autoLogin={this.autoLogin}
            onSignout={() => {
                this.setAutoSignInDisabled(true);
                this.setState({ signedOut: true, account: null })
                this.clearLocal();
            }}
            firstRun={initMustSetup}
            title={title}
            exchangeItemID={itemID}
        />

        //return (
        //    <div className='ms-welcome'>
        //        <Header logo='assets/logo-filled.png' title={this.props.title} message='MailMerge365 is loading' />

        //        <p className="ms-font-xl">Welcome to MailMerge365</p>
        //        <p className="ms-font-m">To start setting up your mail merge campaign upload a file containing at least a list of email addresses. You can add up to 50 additional columns to personalize the email.</p>

        //    </div>
        //);
    }
}
